// Custom
export const feature = '#4D5054'
export const focus = '#7C7E82'
export const trivial = '#DBE0E6'
export const subtle = '#F1F3F5'
export const white = '#FFFFFF'
export const clear = 'transparent'

//Biker Mobile
export const jetBlack = '#000000'
export const darkCharcoal = '#1F1F1F'
export const brightOrange = '#FF6A00'
export const softGray = '#CCCCCC'
//SR
export const srGreen = "#8DC63F"
export const srDarkGreen = '#195820'
export const srPlaceholder = '#959595'
export const srTextInput = '#1E1E1E'